import React,{useState} from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {Link} from 'react-router-dom';
const {FiMapPin,FiUsers,FiStar,FiTrendingUp,FiEye,FiCalendar,FiDollarSign,FiFilter,FiGrid,FiList}=FiIcons;

const PortfolioSection=()=> {
  const [selectedFilter,setSelectedFilter]=useState('all');
  const [viewMode,setViewMode]=useState('grid');
  
  const properties=[
    {
      id: 1,
      title: "Villa Frontemare Monterosso",
      location: "Cinque Terre,Liguria",
      type: "Villa di Lusso",
      category: "luxury",
      guests: 8,
      rating: 4.9,
      reviews: 127,
      revenue: "+65%",
      monthlyRevenue: "€4.200",
      previousRevenue: "€2.500",
      occupancy: "85%",
      image: "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1753287373694-blob",
      features: [
        "Vista mare mozzafiato",
        "Piscina privata infinity",
        "Terrazza panoramica 360°",
        "Chef su richiesta"
      ],
      description: "Villa esclusiva con vista diretta sul mare delle Cinque Terre,completamente ristrutturata con standard 5 stelle.",
      managementPeriod: "18 mesi",
      achievements: [
        "Superhost Gold",
        "Top 1% Cinque Terre",
        "Award Eccellenza 2024"
      ]
    },
    {
      id: 2,
      title: "Residence Gli Oleandri",
      location: "Val d'Orcia,Toscana",
      type: "Residence",
      category: "family",
      guests: 6,
      rating: 4.8,
      reviews: 89,
      revenue: "+42%",
      monthlyRevenue: "€2.800",
      previousRevenue: "€1.950",
      occupancy: "78%",
      image: "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1753287967247-oleandri02-461242530.jpg",
      features: [
        "Piscina condominiale",
        "Giardino privato",
        "Posto auto coperto",
        "Area BBQ"
      ],
      description: "Elegante residence immerso nella campagna toscana,perfetto per famiglie e coppie in cerca di relax.",
      managementPeriod: "12 mesi",
      achievements: [
        "Family Friendly Award",
        "Eco-Friendly Certified",
        "Guest Favorite 2024"
      ]
    },
    {
      id: 3,
      title: "Loft Design Milano Centro",
      location: "Brera,Milano",
      type: "Loft Moderno",
      category: "business",
      guests: 4,
      rating: 4.9,
      reviews: 156,
      revenue: "+78%",
      monthlyRevenue: "€3.200",
      previousRevenue: "€1.800",
      occupancy: "92%",
      image: "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1753288194892-Loft-in-vendita-milano-608858958.jpg",
      features: [
        "Design contemporaneo",
        "Centro città",
        "Smart home tech",
        "Terrazza privata"
      ],
      description: "Loft di design nel cuore di Brera,ideale per business travelers e city breaks di lusso.",
      managementPeriod: "8 mesi",
      achievements: [
        "Business Travel Award",
        "Tech Innovation Prize",
        "Milano Top Host"
      ]
    }
  ];

  const filters=[
    {key: 'all',label: 'Tutti gli Immobili',count: properties.length},
    {key: 'luxury',label: 'Luxury',count: properties.filter(p=> p.category==='luxury').length},
    {key: 'family',label: 'Family',count: properties.filter(p=> p.category==='family').length},
    {key: 'business',label: 'Business',count: properties.filter(p=> p.category==='business').length}
  ];

  const filteredProperties=selectedFilter==='all' 
    ? properties 
    : properties.filter(property=> property.category===selectedFilter);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <motion.div
            initial={{opacity: 0,y: 20}}
            whileInView={{opacity: 1,y: 0}}
            transition={{duration: 0.6}}
            viewport={{once: true}}
            className="mb-6"
          >
            <span className="bg-primary-600 text-white px-4 py-2 rounded-full text-sm font-semibold">
              Portfolio di Successo
            </span>
          </motion.div>
          <motion.h2
            initial={{opacity: 0,y: 20}}
            whileInView={{opacity: 1,y: 0}}
            transition={{duration: 0.6,delay: 0.1}}
            viewport={{once: true}}
            className="text-3xl md:text-5xl font-bold text-warm-900 mb-6"
          >
            Alcuni dei nostri immobili in gestione
          </motion.h2>
          <motion.p
            initial={{opacity: 0,y: 20}}
            whileInView={{opacity: 1,y: 0}}
            transition={{duration: 0.6,delay: 0.2}}
            viewport={{once: true}}
            className="text-xl text-warm-600 max-w-3xl mx-auto leading-relaxed"
          >
            Scopri alcuni degli immobili che gestiamo con successo in tutta Italia. Ogni proprietà è un caso studio di eccellenza nel settore degli affitti brevi.
          </motion.p>
        </div>

        {/* Filters and View Controls */}
        <motion.div
          initial={{opacity: 0,y: 20}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.6,delay: 0.4}}
          viewport={{once: true}}
          className="flex flex-col lg:flex-row justify-between items-center mb-12 gap-6"
        >
          <div className="flex flex-wrap gap-3">
            {filters.map((filter)=> (
              <button
                key={filter.key}
                onClick={()=> setSelectedFilter(filter.key)}
                className={`px-4 py-2 rounded-lg font-medium transition-colors flex items-center space-x-2 ${
                  selectedFilter===filter.key 
                    ? 'bg-primary-600 text-white' 
                    : 'bg-warm-100 text-warm-700 hover:bg-primary-50 hover:text-primary-600'
                }`}
              >
                <span>{filter.label}</span>
                <span className={`text-xs px-2 py-0.5 rounded-full ${
                  selectedFilter===filter.key ? 'bg-white/20' : 'bg-warm-200'
                }`}>
                  {filter.count}
                </span>
              </button>
            ))}
          </div>
          <div className="flex items-center space-x-3">
            <SafeIcon icon={FiFilter} className="h-5 w-5 text-warm-600" />
            <div className="flex bg-warm-100 rounded-lg p-1">
              <button
                onClick={()=> setViewMode('grid')}
                className={`p-2 rounded-md transition-colors ${
                  viewMode==='grid' ? 'bg-white shadow-sm' : 'hover:bg-warm-200'
                }`}
              >
                <SafeIcon icon={FiGrid} className="h-4 w-4" />
              </button>
              <button
                onClick={()=> setViewMode('list')}
                className={`p-2 rounded-md transition-colors ${
                  viewMode==='list' ? 'bg-white shadow-sm' : 'hover:bg-warm-200'
                }`}
              >
                <SafeIcon icon={FiList} className="h-4 w-4" />
              </button>
            </div>
          </div>
        </motion.div>

        {/* Properties Grid */}
        <div className={`grid gap-8 ${viewMode==='grid' ? 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3' : 'grid-cols-1'}`}>
          {filteredProperties.map((property,index)=> (
            <motion.div
              key={property.id}
              initial={{opacity: 0,y: 20}}
              whileInView={{opacity: 1,y: 0}}
              transition={{duration: 0.6,delay: index * 0.1}}
              viewport={{once: true}}
              className={`bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 group ${
                viewMode==='list' ? 'flex flex-col lg:flex-row' : ''
              }`}
            >
              <div className={`relative ${viewMode==='list' ? 'lg:w-1/2' : ''}`}>
                <img 
                  src={property.image} 
                  alt={property.title} 
                  className={`w-full object-cover group-hover:scale-105 transition-transform duration-300 ${
                    viewMode==='list' ? 'h-64 lg:h-full' : 'h-64'
                  }`} 
                />
                <div className="absolute top-4 right-4 bg-primary-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                  {property.type}
                </div>
                <div className="absolute bottom-4 left-4 bg-black/70 backdrop-blur-sm text-white px-3 py-1 rounded-full text-sm flex items-center">
                  <SafeIcon icon={FiTrendingUp} className="h-3 w-3 mr-1" />
                  {property.revenue}
                </div>
                <div className="absolute top-4 left-4">
                  <div className="flex flex-wrap gap-1">
                    {property.achievements.slice(0,1).map((achievement,i)=> (
                      <span 
                        key={i} 
                        className="bg-yellow-500 text-white px-2 py-1 rounded-md text-xs font-medium"
                      >
                        {achievement}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
              <div className={`p-6 ${viewMode==='list' ? 'lg:w-1/2' : ''}`}>
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h3 className="text-xl font-bold text-warm-900 mb-2 group-hover:text-primary-600 transition-colors">
                      {property.title}
                    </h3>
                    <div className="flex items-center text-warm-600 mb-2">
                      <SafeIcon icon={FiMapPin} className="h-4 w-4 mr-1" />
                      <span className="text-sm">{property.location}</span>
                    </div>
                  </div>
                </div>
                <p className="text-warm-600 text-sm mb-4 leading-relaxed">
                  {property.description}
                </p>

                {/* Performance Metrics */}
                <div className="grid grid-cols-2 gap-4 mb-4 p-4 bg-warm-50 rounded-lg">
                  <div>
                    <div className="text-lg font-bold text-green-600">
                      {property.monthlyRevenue}
                    </div>
                    <div className="text-xs text-warm-600">
                      Ricavi attuali/mese
                    </div>
                  </div>
                  <div>
                    <div className="text-lg font-bold text-primary-600">
                      {property.occupancy}
                    </div>
                    <div className="text-xs text-warm-600">
                      Tasso occupazione
                    </div>
                  </div>
                </div>

                {/* Stats Row */}
                <div className="flex items-center justify-between mb-4 text-sm">
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center">
                      <SafeIcon icon={FiUsers} className="h-4 w-4 mr-1 text-warm-500" />
                      <span className="text-warm-600">{property.guests} ospiti</span>
                    </div>
                    <div className="flex items-center">
                      <SafeIcon icon={FiStar} className="h-4 w-4 mr-1 text-yellow-400 fill-current" />
                      <span className="font-medium text-warm-700">
                        {' '}{property.rating} ({property.reviews})
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center text-warm-500">
                    <SafeIcon icon={FiCalendar} className="h-4 w-4 mr-1" />
                    <span className="text-xs">{property.managementPeriod}</span>
                  </div>
                </div>

                {/* Features */}
                <div className="mb-4">
                  <h4 className="font-semibold text-warm-900 mb-2 text-sm">
                    Caratteristiche Premium:
                  </h4>
                  <div className="space-y-1">
                    {property.features.map((feature,featureIndex)=> (
                      <div key={featureIndex} className="text-xs text-warm-600 flex items-center">
                        <span className="w-1 h-1 bg-primary-600 rounded-full mr-2 flex-shrink-0"></span>
                        {feature}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Achievements */}
                <div className="flex flex-wrap gap-1">
                  {property.achievements.map((achievement,i)=> (
                    <span 
                      key={i} 
                      className="bg-primary-100 text-primary-700 px-2 py-1 rounded-md text-xs font-medium"
                    >
                      {achievement}
                    </span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;